import { render, staticRenderFns } from "./add-case-status.vue?vue&type=template&id=1508e2f2&scoped=true"
import script from "./add-case-status.vue?vue&type=script&lang=ts"
export * from "./add-case-status.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508e2f2",
  null
  
)

export default component.exports